module.exports = __webpack_public_path__ + "static/media/bg_feature_2.e39fc97b.jpg";